import { axios } from "../helpers"

export default {
    state: {
        blocksData: [],
        blocksLoadStatus: 0,
        forceRerender: 0,
    },
    getters: {
        getBlocksData(state) {
            return state.blocksData
        },
        getForceRerender(state) {
            return state.forceRerender
        },
        getBlocksLoadStatus(state) {
            return state.blocksLoadStatus
        },
    },
    mutations: {
        setBlocksData(state, blocksData) {
            state.blocksData = blocksData;
        },
        setBlocksLoadStatus(state, status) {
            state.blocksLoadStatus = status;
        },
        addBlock(state, id) {
            state.blocksData.push({
                'type': id,
                'expanded': null,
                'show_year_of_birth': null,
                'email': null,
                'translations': {
                    'nl': {
                        'title': null,
                        'content': null,
                        'button_txt': null,
                        'button_url': null,
                        'links_txt_1': null,
                        'links_url_1': null,
                        'links_txt_2': null,
                        'links_url_2': null,
                    },
                    'fr': {
                        'title': null,
                        'content': null,
                        'button_txt': null,
                        'button_url': null,
                        'links_txt_1': null,
                        'links_url_1': null,
                        'links_txt_2': null,
                        'links_url_2': null,
                    },
                    'en': {
                        'title': null,
                        'content': null,
                        'button_txt': null,
                        'button_url': null,
                        'links_txt_1': null,
                        'links_url_1': null,
                        'links_txt_2': null,
                        'links_url_2': null,
                    }
                },
                'themes': {},
                'errors': {},
            });
        },
        deleteBlock(state, index) {
            state.blocksData.splice(index, 1);
        },
        moveUpBlock(state, index) {
            if(index > 0) {
                state.blocksData.splice(index - 1, 0, state.blocksData.splice(index, 1)[0]);
            }
        },
        moveDownBlock(state, index) {
            if(index < state.blocksData.length - 1) {
                state.blocksData.splice(index + 1, 0, state.blocksData.splice(index, 1)[0]);
            }
        },
        setErrors(state, errors) {
            state.forceRerender += 1;
            const keys = Object.keys(errors);

            keys.forEach(function(key) {
                const splits = key.split('.');

                if(splits[1] == 'translations') {
                    if(! state.blocksData[splits[0]].errors.hasOwnProperty([splits[1]])) {
                        state.blocksData[splits[0]].errors[splits[1]] = {};
                    }
                    if(! state.blocksData[splits[0]].errors[splits[1]].hasOwnProperty([splits[2]])) {
                        state.blocksData[splits[0]].errors[splits[1]][splits[2]] = {};
                    }

                    state.blocksData[splits[0]].errors[splits[1]][splits[2]][splits[3]] = errors[key][0];

                    return;
                }

                if(splits[1] == 'themes') {
                    if(! state.blocksData[splits[0]].errors.hasOwnProperty([splits[1]])) {
                        state.blocksData[splits[0]].errors[splits[1]] = {};
                    }

                    state.blocksData[splits[0]].errors[splits[1]][splits[2]] = errors[key][0];

                    return;
                }

                state.blocksData[splits[0]].errors[splits[1]] = errors[key][0];
            });
        },
        removeErrors(state) {
            state.blocksData.forEach(function(block) {
                block.errors = {};
            });
        },
    },
    actions: {
        loadBlocksData({commit}, data) {
            commit('setBlocksLoadStatus', 1);

            axios
                .get('/blocks', { params: data })
                    .then(response => {
                        commit('setBlocksData', response.data);
                        commit('setBlocksLoadStatus', 2);
                    }).catch(() => {
                        commit('setBlocksData', {});
                        commit('setBlocksLoadStatus', 3);
                    });
        },
        addBlock({commit}, data) {
            commit('addBlock', data.id)
        },
        deleteBlock({commit}, data) {
            commit('deleteBlock', data.index)
        },
        moveUpBlock({commit}, data){
            commit('moveUpBlock', data.index);
        },
        moveDownBlock({commit}, data) {
            commit('moveDownBlock', data.index);
        },
        storeBlocks({commit, state}, data) {
            commit('removeErrors');

            axios
                .post(data.locale + '/admin/sites/' + data.site_id +'/blocks', state.blocksData)
                    .then(response => {
                        window.location='/' + data.locale + '/admin/sites';
                    }).catch(error => {
                        if(error.response.status == 422) {
                            const errors = error.response.data.errors;
                            commit('setErrors', errors);
                        }
                    });
        },
    }
}
